import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Container, InputGroup,  Form, Button, ButtonGroup, Card, Alert, Spinner, Modal, ModalBody } from "react-bootstrap"
import { Link, Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core'
import { Paper, TextField, Checkbox, Select, InputLabel, FormControl, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import axios from "axios"
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserContext } from "./Context/UserContext";
import { ToastContainer, toast } from "react-toastify"
import Timer from "./Timer"
import { LoaderC } from "./LoaderC"
import Loader from "react-loader-spinner";
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Otp } from 'react-otp-timer';
//import FormControl from '@material-ui/core/FormControl';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import 'react-toastify/dist/ReactToastify.css';
import "./login.css"
import "./common.css"
import "./readytoshop.css"
import CustomerDashboard from './CustomerDashboard';
import { base_url } from '../globalConstants';


const mystyle = {
  color: "white",
  backgroundColor: "#FF7F50",
  fontFamily: "Arial",
  borderRadius: "12px"
};

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      // margin: theme.spacing(1),
      margin: '5px',
      width: '25ch',
    },
  },
  paper: {
    // padding: theme.spacing(2),
    padding: '30px',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  spaceBetweenFields: {
    // marginTop: '10px',
    marginBottom: '10px'
  }  
}));



export default function EditGetUserAddress(props) {

  // NEW CODE VARS
  const classes = useStyles();
  const [isEditAddress, setIsEditAddress] = useState(props.isEditOption);
  const [errorText3, setErrorText3] = useState(' ');

  const [userDetails,setUserDetails]=useState([])
  const [shippingAddress1,setShippingAddress1]=useState('')
  const [shippingAddress2,setShippingAddress2]=useState('')
  const [shippingCountry,setShippingCountry]=useState('')
  const [shippingCountryName,setShippingCountryName]=useState('')
  const [shippingState,setShippingState]=useState('')
  const [shippingStateName,setShippingStateName]=useState('')
  const [shippingCity,setShippingCity]=useState('')
  const [shippingZipCode,setShippingZipCode]=useState('')
  const [countryList,setCountryList]=useState({})
  // const [shippingCity,setShippingCity]=useState(userDetails.city)    //Old
  


  const [isBillingAddress, setIsBillingAddress] = useState(false)
  const [billingDetails,setBillingDetails] = useState([])
  const [billingDataExists, setBillingDataExists] = useState('')
  const [billingAddress1,setBillingAddress1]=useState('')
  const [billingAddress2,setBillingAddress2]=useState('')
  const [billingCountry,setBillingCountry] = useState('')
  const [billingCountryName,setBillingCountryName] = useState('')
  const [billingState,setBillingState] = useState('')
  const [billingCity,setBillingCity] = useState('')
  const [billingZipCode,setBillingZipCode] = useState('')
  const [billingStateName,setBillingStateName] = useState('')
  const [billingStatesList, setBillingStatesList] = useState([])

  const [tinno, setTinno] = useState('')
  

  // const [billingCity,setbillingCity] = useState("")
  // const [billingAddress1,setBillingAddress1]=useState("")
  // const [billingAddress2,setBillingAddress2]=useState("")
  // const [billingZipCode,setBillingZipCode] = useState("")
  // const [billingCountry,setBillingCountry] = useState("")
  // const [billingCountryName,setBillingCountryName] = useState("")
  // const [billingState,setBillingState] = useState("")
  // const [billingStateName,setBillingStateName] = useState("")
  // const [billingStatesList, setBillingStatesList] = useState([])

  const [isAddressSame, setIsAddressSame] = useState(false)

  const [show, setShow] = useState(false);

  const CHARACTER_LIMIT = 10; 

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const handleShowAddressModal = () => setShow(true);
  //  --NEW CODE VARS

  //
  const [checkAddressSame,setCheckAddressSame] = useState(false)

  const handleAddressSame = e =>{
    setCheckAddressSame(e.target.checked)
    setIsAddressSame(!isAddressSame)

    console.log('checkAddressSame',checkAddressSame);
    console.log('isAddressSame',isAddressSame);

    if(e.target.checked){
      setBillingAddress1(shippingAddress1);
      setBillingAddress2(shippingAddress2);
      setBillingCountry(shippingCountry);
      setBillingState(shippingState);
      setBillingCity(shippingCity);     
      setBillingZipCode(shippingZipCode);
    }
    else{
      setBillingAddress1('');
      setBillingAddress2('');
      setBillingCountry('');
      setBillingState('');
      setBillingCity('');     
      setBillingZipCode('');      
    }
  }

  //VARS FROM SIGNUP
  
  const [selectedValue, setSelectedValue] = React.useState('b');
  const [FixShippingState,setFixShippingState]=useState('');
  const [ShippingDistrict,setShippingDistrict]=useState('');
  const [Details,setDetails]=useState([]);
  const [stateList,setStateList]=useState([]);
  
  //--VARS FROM SIGNUP


  // NEW MODAL
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  // const [focusAfterClose, setFocusAfterClose] = useState(true);

  const toggle = () => setOpen(!open);
  const toggle2 = () => setOpen2(!open2);


  //toggle

  const [Toggler, setToggler] = useState(true);
  //NEW MODAL

  //login way decision variable

  const context = useContext(UserContext);
  const [Logged, setLogged] = useState(false);
  const [Id, setId] = useState('');
  const [Countries, setCountries] = useState([]);
  const [CountrySelected, setCountrySelected] = useState('')
  const [CurrentToggleState, setCurrentToggleState] = useState('Login via Email');
  const [estate,setestate]=useState('')
  const [ShippingStateFinal,setShippingStateFinal]=useState('')
  const [username,setusername]=useState('')
  const [validated,setValidated]=useState(false);
  const [EzzId,setEzzId]=useState('')
  const [modalVisible,setModalVisbile]=useState(props.showAddressModal)
  
  //USER ADDRESS 

  const handleTinno=(event)=>{
    setTinno(event.target.value)
  }

  const handleShippingAddress1=(event)=>{
    setShippingAddress1(event.target.value)
  }
  
  const handleShippingAddress2=(event)=>{
    setShippingAddress2(event.target.value)    
  }
  
  const handleShippingCity=(event)=>{
    setShippingCity(event.target.value)    
  }
  
  const handleShippingZipCode=(event)=>{
    setShippingZipCode(event.target.value)
  }


  const handleShippingChangeCountry=(event)=>{

    setShippingCountry(event.target.value);


    
      // Countries.map(keys=>{
      //   if(keys.name===event.target.value){
      //     setStateList(keys.states);
    
      //   }
      // })
    }

  const handleShippingStateChange=(event)=>{
    console.log('STATELIST', stateList);
    if(selectedValue==='a'){
      
      console.log(event.target.value[0][0])
      console.log(event.target.value)
      setFixShippingState(event.target.value[0][0]);
      stateList.map(key=>{
        if(key.state_name===event.target.value){
          setestate(key.state_id);
          // setShippingStateFinal(key.state_name);
          setShippingStateName(key.state_name);
          setShippingDistrict(key.state_name);
          setShippingState(key.state_id);
        }
      })
    }else{
      
      console.log(event.target.value[0])
      console.log(event.target.value[0][0])
      
      stateList.map(key=>{
        if(key.state_name===event.target.value){
          setestate(key.state_id);
          // console.log('statename', key.state_name);
          setShippingState(key.state_id);
          setShippingStateName(key.state_name);
        }
    })
     
    }
  
   
    console.log(`state- ${event.target.value[0][0]}`)
  }



  //HANDLE BILLING ADDRESS
  
  const handleBillingCountryChange=(event)=>{    
    // console.log('Countries',Countries);    
    setBillingCountryName(event.target.value);
    Countries.map(keys=>{
      if(keys.name===event.target.value){
        setBillingCountry(keys.country_id);
        setBillingStatesList(keys.states);
        }
      })
    }

  const handleBillingStateChange=(event)=>{
    console.log('STATELIST', billingStatesList);
    if(selectedValue==='a'){
      
      console.log(event.target.value[0][0])
      console.log(event.target.value)
      // setFixShippingState(event.target.value[0][0]);
      billingStatesList.map(key=>{
        if(key.state_name===event.target.value){
          // setestate(key.state_id);
          // setShippingStateFinal(key.state_name);
          // setShippingDistrict(key.state_name);
          setBillingState(key.state_id);
          setBillingStateName(key.state_name);
        }
      })
    }else{
      
      console.log(event.target.value[0])
      console.log(event.target.value[0][0])
      
      billingStatesList.map(key=>{
        if(key.state_name===event.target.value){
          // setestate(key.state_id);
          // console.log('statename', key.state_name);
          setBillingState(key.state_id);
          setBillingStateName(key.state_name);
        }
    })
     
    }
  
   
    console.log(`state- ${event.target.value[0][0]}`)
  }
  //--HANDLE BILLING ADDRESS END

  //--USER ADDRESS


  const handleSubmit = async e => {

    e.preventDefault();

    // const Formdata = new FormData();
    // Formdata.append('email', Email);
    // Formdata.append('password', Password);
    // if (shippingCountryName.toUpperCase() === 'CURACAO' &&  tinno.length <= 0)
    // {
    //   alert("CRIB/Tax Identification No. is mandatory!");
    //   return;
    // }
    const formdata={
      address: shippingAddress1,
      address_2: shippingAddress2,
      city: shippingCity,
      state: shippingState,
      zipcode: shippingZipCode,
      tinno: tinno
    }

    const billing_formdata={
      address_line_1: billingAddress1, 
      address_line_2: billingAddress2, 
      city: billingCity,
      state: billingState,
      zipcode: billingZipCode,
      country:billingCountry,
      ezz_id: EzzId,
    }

    // console.log(formdata);
    console.log(billing_formdata);

    await axios({
      method: 'PATCH',
      url: base_url+`customers/${EzzId}/`,
      data: formdata,
      headers: { 'Content-Type': 'application/json' }
    })
      .then(async function (response) {
        //handle success

        console.log('billingDataExists',billingDataExists)
        console.log('billingDetails',billingDetails)

        // if(billingDataExists){
        if(isBillingAddress){

          await axios({
            method: 'PATCH',
            url: base_url+`customer_billing_address/${EzzId}/`,
            data: billing_formdata,
            headers: { 'Content-Type': 'application/json' }
          }).then((response) => {
            console.log(response)
            setBillingDetails(response.data)
            setModalVisbile(false)
            
          }).catch((response) => {
            console.log(response)
          })
          
        }
        else{
          await axios({
            method: 'POST',
            url: base_url+`customer_billing_address/`,
            data: billing_formdata,
            headers: { 'Content-Type': 'application/json' }
          }).then((response) => {
            console.log(response)
              setBillingDataExists(true)
              setBillingDetails(response.data)
              setModalVisbile(false)

            }).catch((response) => {
              console.log(response)
            })
        }

        console.log(response.data)
        setUserDetails(response.data)
        // setModalVisbile(false)

        // localStorage.setItem('logged', 'true');
        // console.log(response);
        // console.log('success');
        // console.log(response.data.user.Id)
        // localStorage.setItem("ezzyid", response.data.user.Id)
        // setId(response.data.user.Id);
        // localStorage.setItem('username', response.data.user.Name);
        // localStorage.setItem("validated", response.data.email_validated);
        // localStorage.setItem('token', response.data.token);
        // setLoading(true);
        // setLogged(true);
      })
      .catch(function (response) {
        //handle error
        console.log(response);
        console.log('error')
        // toast.warn('Invalid UserName or Password')
      });
  }


  // const getUserCountry = async () => {
  //   // console.log("EZZZZZZ2", ezz_id);
  //   const { data } = await axios.get(`http://ezzytrace.com/api/v1/ezzytrace/customers/${localStorage.getItem('ezzyid')}/`)
  //   console.log('DATAAAAA', data);
  //   console.log('DATAAAAA country', data.country);
  //   console.log('countryListttttttttttttt', countryList)
  //   setShippingCountry(countryList[tempCountry])    
  //   // console.log('countryList[data.country]', tempCountry)
  //   console.log('shipCOUNTRY',countryList[tempCountry])
  // }

  const fetchcountries = async e => {
    // const { data } = await axios.get('http://ec2-3-131-16-17.us-east-2.compute.amazonaws.com/api/v1/ezzytrace/country_state_details/')
    // console.log(data)
    // setCountries(data);
    // console.log('countries',Countries)

    // var country_name_list = {}

    // for( var key in data )
    //   country_name_list[data[key].country_id] = data[key].name
     
    // console.log('COUNTRYNAME', country_name_list );     
    // await setCountryList(country_name_list)


     await axios(
      {
        method: 'get',
        url: base_url + 'country_state_details/',
        headers: { 'Content-Type': 'application/json' }
      }
    )
      .then(function (response) {
        console.log(response.data)
        setCountries(response.data);
        console.log('countries', Countries) 
        
        var tempCountries = response.data
        console.log('countries', tempCountries) 
        var country_name_list = {}

        for (var key in response.data)
          country_name_list[response.data[key].country_id] = response.data[key].name

        console.log('COUNTRYNAME', country_name_list);

        axios({
          method: 'get',
          url: base_url + `customers/${localStorage.getItem('ezzyid')}/`,
          headers: { 'Content-Type': 'application/json' }
        }).then(function(response){
          // console.log(response)
          // console.log(response.data)
          var countryName = country_name_list[response.data.country]
          console.log(response.data.country)
          console.log('countryName',countryName)
          setShippingCountry(response.data.country)
          setShippingCountryName(countryName)
          console.log("SHIP COUNTRY",shippingCountry)

          tempCountries.map(keys=>{
              if(keys.name===countryName){
                setStateList(keys.states);
                console.log('statelist',stateList);          
              }
            })

        fetchBillingDetails(localStorage.getItem('ezzyid'),tempCountries);


        }).catch(function(response){
          console.log(response);
        })
        
        // setCountryList(country_name_list)
        console.log('COUNTRYNAME setState', countryList)       
        
      })
      .catch(function (response) {
        console.log(response);
      })



    // setCountryList((state) => {
    //   console.log(state);
    //   console.log('COUNTRYNAME', countryList );        
    //   return state;
    // });

  }

  const checkUserAddress = async () => {

    await axios({
      method: 'get',
      url: base_url+`customers/${localStorage.getItem('ezzyid')}/`,
      headers: { 'Content-Type': 'application/json' }
    }).then(function(response){
      console.log(response)
      console.log(response.data)

      const userDetails =  response.data

      // setIsEmailValidated(response.data.email_validated)
      setUserDetails(userDetails)
      setShippingAddress1(userDetails.address)
      setShippingAddress2(userDetails.address_2)
      setShippingCountry(userDetails.country)
      setShippingCountryName(userDetails.country_name)
      setShippingState(userDetails.state)
      setShippingStateName(userDetails.state_name)
      setShippingCity(userDetails.city)
      // setShippingZipCode(userDetails.zipcode)
      setShippingZipCode(response.data.zipcode)
      setTinno(userDetails.tinno)

        if (!userDetails.address || !userDetails.state || !userDetails.city || !userDetails.zipcode ) {
          setShow(true)   
        } else
          setShow(false)   

    }).catch(function(response){
      console.log(response);
    })

   

  }

  const fetchBillingDetails = async (userEzzId, countryList) =>{

    console.log(userEzzId);
    const billingUrl = base_url +  `customer_billing_address/${userEzzId}/`

    // const {data} = await axios.get(billingUrl)
    
    await axios.get(billingUrl)
    .then(res=>{
      console.log('res',res)
      setIsBillingAddress(true)
      setBillingDetails(res.data)
      // setUserBillingAddress(res.data.address_line_1 + ', ' + res.data.address_line_2)
      // setUserBillingCountry(res.data.country)
      // setUserBillingCountry(countryList[data.country])
      // setUserBillingState(res.data.state_name)
      // setUserBillingCity(res.data.city)
      // setUserBillingZipcode(res.data.zipcode)
      setBillingAddress1(res.data.address_line_1)
      setBillingAddress2(res.data.address_line_2)
      setBillingCountry(res.data.country)
      setBillingCountryName(res.data.country_name)
      setBillingState(res.data.state)
      setBillingStateName(res.data.state_name)
      setBillingCity(res.data.city)
      setBillingZipCode(res.data.zipcode)


      console.log('country',countryList);          

      countryList.map(keys=>{
        if(keys.name===res.data.country_name){
          setBillingStatesList(keys.states);
          console.log('billingStatesList',billingStatesList);          
        }
      })

    }).catch(err=>{
      setIsBillingAddress(false)
      setBillingDetails({})
      console.log('err',err)
    })

    // console.log('billingData',data);

    // if(data){
    //   setBillingDetails(data)
    //   setUserBillingAddress(data.address_line_1+', '+data.address_line_2)
    //   setUserBillingCountry(data.country)
    //   // setUserBillingCountry(countryList[data.country])
    //   setUserBillingState(data.state_name)
    //   setUserBillingCity(data.city)
    //   setUserBillingZipcode(data.zipcode)
    // }

  }    

  useEffect(() => {
    fetchcountries();
    setusername(localStorage.getItem('username'));
    setValidated(localStorage.getItem('validated'));
    setEzzId(localStorage.getItem('ezzyid'));

    var temp_ezz = localStorage.getItem('ezzyid')

    setEzzId(temp_ezz)

    checkUserAddress();

    // getUserCountry()

    // console.log("EZZZZZZ1", EzzId);
    // console.log("EZZZZZZ1", temp_ezz);
    // getUserCountry(EzzId);
    // getUserCountry(temp_ezz);

    // setShippingCountry(''));
    // localStorage.setItem('logged', 'false');
  }, [])

  return (
    <div>
      {localStorage.getItem('logged') ==='true' ? ' ': <Redirect to="/"/>}

      <Modal size="lg" show={modalVisible}  >
      {/* <Modal size="lg" show={props.showAddressModal} onHide={handleClose}> */}

        <Modal.Body>

          <CloseIcon onClick={()=>setModalVisbile(false)} style={{ display: 'flex', float: 'right', cursor: 'pointer', margin: '3px 5px 0 0' }}  /><br/>

          <Container>
            <Row> 


              {/* <Button variant="secondary" onClick={handleClose}>
                Close
              </Button> */}

            </Row>

            <Row>

              <Col lg={{ span: 12 }}>

                {/* <Paper className="justify-content-md-center" className={classes.paper} elevation={5} alignContent="center"  > */}
                    <h3 className='mainHeading' >Update Address</h3>
               
                <p className='secondaryHeading' >
                  To make it easier, you can go ahead and fill out the following<br />
                  information for your account.<br/>
                  <span style={{ color: "red", textAlign: "center" }}>{errorText3}</span>
                </p>

                <Form onSubmit={handleSubmit}>

                  <Row>
                    <Col lg={{ span: 6 }}>
                      <h5 className='miniHeading' >Shipping Address</h5>
                      <Row >
                        <Col className="justify-content-md-center"  >
                          <TextField id="shippingAddress1" label="Address 1" variant="filled" className='textField' required fullWidth 
                            onChange={handleShippingAddress1} value={shippingAddress1} />
                        </Col>
                      </Row><br />
                      <Row >
                        <Col className="justify-content-md-center"  >
                          <TextField id="shippingAddress2" label="Address 2" variant="filled" className='textField' fullWidth 
                            onChange={handleShippingAddress2} value={shippingAddress2} />
                        </Col>
                      </Row><br />
                      <Row>
                        <Col className="justify-content-md-center" >

                        <TextField id="shippingCountry" label="Country" value={shippingCountryName} variant="filled" disabled
                            className='textField' fullWidth  
                            InputProps={{
                              readOnly: true,
                            }}/>

                          {/* <FormControl variant="filled" className={classes.formControl} className='textField' fullWidth>
                            <InputLabel required htmlFor="selectShippingCountry" id='selectShippingCountry-label' >Country</InputLabel>
                            <Select required fullWidth
                              native
                              defaultValue={ shippingCountry }
                              // onChange={handleShippingChangeCountry}
                              inputProps={{
                                name: 'shippingCountry',
                                id: 'selectShippingCountry',
                              }}
                            >
                              <option aria-label="None" value="" />
                              {Countries.map(key => {
                                return (
                                  <option>{key.name}</option>
                                )
                              })}
                            </Select>
                          </FormControl> */}


                        </Col>
                      </Row><br />                      
                      <Row >
                        <Col className="justify-content-md-center"  >

                          <FormControl variant="filled" className={classes.formControl} className='textField' fullWidth>
                            <InputLabel htmlFor="selectShippingState" id='selectShippingState-label' >State/Region</InputLabel>
                            <Select fullWidth
                              native
                              // defaultValue="State"
                              // value={userDetails.state_name}
                              value={shippingStateName}
                              onChange={handleShippingStateChange}
                              inputProps={{
                                name: 'shippingState',
                                id: 'selectShippingState',
                              }}
                            >
                              <option aria-label="None" value="" />
                              {stateList.map(key => {
                                return (
                                  <option value={key.state_name}>{key.state_name}</option>
                                )
                              })}
                            </Select>
                          </FormControl>

                        </Col>
                      </Row><br />
                      <Row >
                        <Col className="justify-content-md-center"  >
                          <TextField id="shippingCity" label="City" variant="filled" className='textField' required fullWidth 
                            onChange={handleShippingCity} value={shippingCity}/>
                        </Col>
                      </Row><br />
                      <Row >
                        <Col className="justify-content-md-center"  >
                          <TextField id="shippingZipCode" label="Zip Code" variant="filled" className='textField' required fullWidth 
                            onChange={handleShippingZipCode} value={shippingZipCode} />
                        </Col>
                      </Row><br />
                      {/* <Row >
                        <Col className="justify-content-md-center"  >
                          <TextField id="phoneNumber" label="Phone Number" variant="filled" className='textField' fullWidth />
                        </Col>
                      </Row><br /> */}
                      <Row >
                        {/*<Col className="justify-content-md-center"  >
                          <TextField id="referralCode" label="Referral Code" variant="filled" className='textField' fullWidth 
                           helperText='Optional'/>
                        </Col>*/}
                        <Col className="justify-content-md-center"  >
                          <TextField id="tinno" label="*CRIB / TIN #" variant="filled" className='textField' fullWidth 
                           helperText='CRIB/TIN Mandatory for CURACAO' onChange={handleTinno} value={tinno}/>
                        </Col>
                      </Row><br />
                    </Col>
                    <Col lg={{ span: 6 }}>
                      <h5 className='miniHeading' >Billing Address</h5>
                      <Row >
                        <Col className="justify-content-md-center"  >
                          <FormControlLabel style={{ paddingTop: '6px' }}
                            control={
                              <Checkbox
                                name="checkedB"
                                color="primary"
                                // value = {checkAddressSame}
                                checked = {checkAddressSame}
                                onChange={handleAddressSame}
                                
                              />
                            }
                            label="Same as Shipping"
                            id='sameAsShippingCheckbox'
                          />
                        </Col>
                      </Row><br />
                      {
                        isAddressSame
                        ?
                          <>
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingAddress1" label="Address 1" disabled value={shippingAddress1} variant="filled" className='textField' fullWidth 
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingAddress1" label="Address 2" disabled value={shippingAddress2} variant="filled" 
                                  className='textField' fullWidth
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="selectBillingCountry" label="Country" disabled value={shippingCountryName} variant="filled"
                                  className='textField' fullWidth
                                  InputProps={{
                                    readOnly: true,
                                  }} />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="selectBillingState" label="State/Region" disabled value={shippingStateName} variant="filled"
                                    className='textField' fullWidth
                                    InputProps={{
                                      readOnly: true,
                                    }} />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingCity" label="City" disabled value={shippingCity} variant="filled" className='textField' fullWidth                                
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingZipCode" label="Zip Code" variant="filled" disabled value={shippingZipCode} className='textField' fullWidth 
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Col>
                            </Row><br />
                          </>
                        :
                          <>
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingAddress1" label="Address 1" onChange={(e) => { setBillingAddress1(e.target.value) }} value={billingAddress1} variant="filled" className='textField' fullWidth />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingAddress1" label="Address 2" onChange={(e) => { setBillingAddress2(e.target.value) }} value={billingAddress2} variant="filled" className='textField' fullWidth />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <FormControl variant="filled" className={classes.formControl} className='textField' fullWidth>
                                  <InputLabel htmlFor="selectBillingCountry" id='selectBillingCountry-label' >Country</InputLabel>
                                  <Select fullWidth
                                    native
                                    // defaultValue="Select your Country"

                                    value={billingCountryName}
                                    // onChange={(e)=>{setBillingCountry(e.target.value)}}
                                    onChange={handleBillingCountryChange}
                                    inputProps={{
                                      name: 'country',
                                      id: 'selectBillingCountry',

                                    }}
                                  >
                                    <option aria-label="None" value="" />

                                    {Countries.map(key => {
                                      return (
                                        <option value={key.name}>{key.name}</option>
                                      )
                                    })}
                                  </Select>
                                </FormControl>
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >

                                <FormControl variant="filled" className={classes.formControl} className='textField' fullWidth>
                                  <InputLabel htmlFor="selectBillingState" id='selectBillingState-label' >State/Region</InputLabel>
                                  {/* {console.log("~~~~~~~~~~",billingState,shippingState)} */}
                                  <Select fullWidth
                                    native
                                    // defaultValue="State"
                                    // onChange={handleBillingChangeState}
                                    value={billingStateName}

                                    onChange={handleBillingStateChange}
                                    inputProps={{
                                      name: 'billingState',
                                      id: 'selectBillingState',
                                    }}
                                  >
                                    <option aria-label="None"  value="" />
                                    {billingStatesList.map(key => {
                                      return (
                                        // console.log(key),
                                        <option value={key.state_name}>{key.state_name}</option>
                                      )
                                    })}
                                  </Select>
                                </FormControl>

                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingCity" label="City" value={billingCity} onChange={(e) => { setBillingCity(e.target.value) }} variant="filled" className='textField' fullWidth />
                              </Col>
                            </Row><br />
                            <Row >
                              <Col className="justify-content-md-center"  >
                                <TextField id="billingZipCode" label="Zip Code" variant="filled"
                                  value={billingZipCode} onChange={(e) => { setBillingZipCode(e.target.value) }} className='textField' fullWidth 
                                  inputProps={{
                                    maxlength: CHARACTER_LIMIT,
                                    type: 'number'
                                  }}
                                  />
                              </Col>
                            </Row><br />
                          </>
                      }             

                    </Col>
                  </Row>
                  <Row>
                    <Col lg={{ span: 8, offset: 2 }} className="justify-content-md-center" >
                            <Button id="getYourUsAddress" size='lg' className="customButton1" type="submit" block >
                              SAVE CHANGES
                            </Button>
                      <br/>
                        <Button id="doThisLater" className="customButton2" variant="outline-primary" size='lg' block 
                          onClick={()=>setModalVisbile(false)} >
                          DO THIS LATER
                        </Button><br/>
                    </Col>
                  </Row><br/>

                </Form>
                {/* </Paper> */}

              </Col>

            </Row>

          </Container>

        </Modal.Body>

      </Modal>


      {/* <Button onClick={handleShow}>Open Modal</Button>                            */}
      


    </div>

  )
}
